import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  en: {
    nav: {
      home: 'Home',
      products: 'Products',
      about: 'About Us',
      contact: 'Contact Us',
      search: 'Search products...',
      allProducts: 'All Products',
      formaldehyde: 'Formaldehyde Series',
      organic: 'Organic Chemicals',
      inorganic: 'Inorganic Chemicals',
      custom: 'Custom Services'
    },
    home: {
      heroTitle: 'Qingdao FTZ Chemical Supply Chain',
      heroSub: 'Professional chemical raw material supply chain service platform, committed to providing global customers with high-quality formaldehyde and chemical products',
      statsTitle: 'Why Choose Us',
      statsSub: 'Backed by Qingdao Free Trade Zone, delivering professional chemical supply chain solutions',
      catTitle: 'Product Categories',
      catSub: 'Comprehensive chemical raw material product lines to meet diverse procurement needs',
      prodTitle: 'Featured Products',
      prodSub: 'High quality chemical raw materials, competitive pricing, professional service',
      aboutTitle: 'About Qingdao FTZ Chemical',
      aboutSub: 'Located in Qingdao Free Trade Zone, we are a professional chemical raw material supply chain service provider',
      aboutDesc: 'With years of experience in chemical trading, we leverage the strategic advantages of Qingdao Free Trade Zone to provide global customers with high-quality formaldehyde series products and other chemical raw materials. Our professional team ensures reliable supply, strict quality control, and efficient logistics services.',
      aboutBtn: 'Learn More',
      contactTitle: 'Get In Touch',
      contactSub: 'Professional team ready to serve you, rapid response to every inquiry',
      flowTitle: 'Service Process',
      flowSub: 'Clear and transparent cooperation process for your peace of mind'
    },
    product: {
      inquire: 'Inquire Now',
      negotiable: 'Negotiable',
      moq: 'MOQ',
      delivery: 'Delivery',
      category: 'Category',
      allCategories: 'All Categories',
      loadMore: 'Load More',
      noResult: 'No matching products found',
      relatedProducts: 'Related Products',
      specs: 'Specifications',
      description: 'Product Description'
    },
    inquiry: {
      title: 'Send Inquiry',
      name: 'Your Name',
      company: 'Company Name',
      email: 'Email Address',
      phone: 'Phone Number',
      product: 'Interested Product',
      message: 'Your Requirements',
      submit: 'Submit Inquiry',
      success: 'Inquiry submitted successfully! We will contact you within 24 hours.',
      error: 'Submission failed. Please try again later.',
      productPlaceholder: 'Select a product',
      messagePlaceholder: 'Please describe your requirements, quantity, specifications, etc.',
      required: 'This field is required',
      emailInvalid: 'Please enter a valid email'
    },
    contact: {
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      wechat: 'WeChat',
      hours: 'Working Hours',
      mapTitle: 'Our Location',
      faqTitle: 'FAQ',
      followUs: 'Follow Us'
    },
    about: {
      title: 'About Us',
      intro: 'Company Introduction',
      history: 'Development History',
      team: 'Core Team',
      cert: 'Honors & Certifications',
      values: 'Our Values'
    },
    footer: {
      about: 'Qingdao FTZ Chemical Info is a professional chemical raw material supply chain service platform. We provide high-quality formaldehyde series and other chemical products to global customers.',
      quickLinks: 'Quick Links',
      products: 'Products',
      contactInfo: 'Contact Info',
      copyright: '© 2024 Qingdao FTZ Chemical Info. All rights reserved.',
      icp: 'ICP License No. XXXXXXXX',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service'
    },
    common: {
      viewMore: 'View More',
      back: 'Back',
      search: 'Search',
      noData: 'No Data',
      loading: 'Loading...'
    }
  },
  zh: {
    nav: {
      home: '首页',
      products: '产品中心',
      about: '关于我们',
      contact: '联系我们',
      search: '搜索产品...',
      allProducts: '全部产品',
      formaldehyde: '甲醛系列',
      organic: '有机化工原料',
      inorganic: '无机化工原料',
      custom: '定制服务'
    },
    home: {
      heroTitle: '青岛自贸区化工供应链',
      heroSub: '专业化工原材料供应链服务平台，致力于为全球客户提供优质甲醛及化工产品',
      statsTitle: '为什么选择我们',
      statsSub: '背靠青岛自贸区，提供专业化工供应链解决方案',
      catTitle: '产品分类',
      catSub: '全面的化工原材料产品线，满足多样化采购需求',
      prodTitle: '精选产品',
      prodSub: '优质化工原料，有竞争力价格，专业服务',
      aboutTitle: '关于青岛自贸化工',
      aboutSub: '位于青岛自贸区，专业的化工原材料供应链服务商',
      aboutDesc: '我们拥有多年化工贸易经验，借助青岛自贸区的战略优势，为全球客户提供优质甲醛系列产品及其他化工原料。专业团队确保可靠供应、严格质量控制和高效物流服务。',
      aboutBtn: '了解更多',
      contactTitle: '联系我们',
      contactSub: '专业团队随时为您服务，快速响应每一次询盘',
      flowTitle: '服务流程',
      flowSub: '清晰透明的合作流程，让您放心采购'
    },
    product: {
      inquire: '立即询盘',
      negotiable: '面议',
      moq: '最小起订量',
      delivery: '交货周期',
      category: '产品分类',
      allCategories: '全部分类',
      loadMore: '加载更多',
      noResult: '未找到匹配产品',
      relatedProducts: '相关产品推荐',
      specs: '规格参数',
      description: '产品描述'
    },
    inquiry: {
      title: '发送询盘',
      name: '您的姓名',
      company: '公司名称',
      email: '电子邮箱',
      phone: '联系电话',
      product: '意向产品',
      message: '需求描述',
      submit: '提交询盘',
      success: '询盘提交成功！我们将在24小时内与您联系。',
      error: '提交失败，请稍后重试。',
      productPlaceholder: '请选择产品',
      messagePlaceholder: '请描述您的需求、数量、规格等',
      required: '此项为必填',
      emailInvalid: '请输入有效邮箱'
    },
    contact: {
      phone: '电话',
      email: '邮箱',
      address: '地址',
      wechat: '微信',
      hours: '工作时间',
      mapTitle: '我们的位置',
      faqTitle: '常见问题',
      followUs: '关注我们'
    },
    about: {
      title: '关于我们',
      intro: '公司介绍',
      history: '发展历程',
      team: '核心团队',
      cert: '荣誉资质',
      values: '企业价值观'
    },
    footer: {
      about: '青岛自贸货物信息网是专业的化工原材料供应链服务平台，为全球客户提供优质甲醛系列及其他化工产品。',
      quickLinks: '快速链接',
      products: '产品中心',
      contactInfo: '联系方式',
      copyright: '© 2024 青岛自贸货物信息网 版权所有',
      icp: 'ICP备案号：XXXXXXXX',
      privacy: '隐私政策',
      terms: '服务条款'
    },
    common: {
      viewMore: '查看更多',
      back: '返回',
      search: '搜索',
      noData: '暂无数据',
      loading: '加载中...'
    }
  }
}

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages
})

export default i18n
